import {Component, Inject, Input, OnInit, PLATFORM_ID} from '@angular/core';
import { MarketProduct } from '../_models/product.interface';
import { Observable, of } from 'rxjs';
import { Store } from '@ngrx/store';
import * as productsSelectors from '../state/product-list/list-selectors';
import { PushToCartComponent } from '@app/marketplace/shared/_components/push-cart.component';
import { UrlService } from '@app/services/url.service';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ViewTypeEnum } from '@app/marketplace/core/enum/viewTypeEnum';
import {isPlatformBrowser} from '@angular/common';
import {isBrowser} from 'ngx-bootstrap/positioning/utils/isBrowser';
import {ProductService} from '@app/marketplace/products/_services/product.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ProductDetailsDlgComponent } from '../product-details-dlg/product-details-dlg.component';

@Component({
  selector: 'app-product-tab1',
  templateUrl: './product-tab1.component.html',
  styleUrls: ['./product-tab1.component.css']
})

export class ProductTab1Component extends PushToCartComponent implements OnInit
{
  @Input()
  data$: Observable<MarketProduct[]>;
  isLoading$: Observable<boolean>;
  count$: Observable<number>;
  theme = { 'min-width': '273px', 'min-height': '219px', background: '#f1f1f1' };
  constructor(
    private store: Store<any>,
    private productService: ProductService,
    private modalService: NgbModal,
    private urlService: UrlService,
    private metaService: Meta,
    private titleService: Title,
    private route: ActivatedRoute,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId) {
     super(route, metaService, titleService, router);
     this.data$ = of([]);
     this.isLoading$ = isPlatformBrowser(platformId) ? this.store.select(productsSelectors.selectLoading) : this.productService.loading$;
     this.count$ = isPlatformBrowser(platformId) ? this.store.select(productsSelectors.selectCount) : this.productService.count$;
  }
  ngOnInit(): void { }
  public pushToCart(product:any) {
    var itemImg = $(`#${product.code}`).find('img').eq(0);
    this.flyToElement($(itemImg),product,ViewTypeEnum.ProductList,this.store);
  }
  openDetails(product:any) {
    const modalRef = this.modalService.open(ProductDetailsDlgComponent, {size: 'xl', modalDialogClass: 'book-address'});
    modalRef.componentInstance.code = product.code;
    modalRef.componentInstance.provider = product.productProvider;
    modalRef.result.then(
      (result: boolean) => {
          if (result) {
            this.router.navigate([`/market/productos-compras-cuba-online/shein/${product.code}`]);
          }
      },() => {}
   )
  }

}
